import { FormControl, FormHelperText, InputLabel, OutlinedInput } from '@mui/material';
import React from 'react';
import { IMaskInput } from 'react-imask';
import { FieldHookConfig, useField } from 'formik';

interface CustomProps {
    onChange: (event: { target: { name: string; value: string } }) => void;
    name: string;
    value: string;
}
const ibanMaskCustom = React.forwardRef<HTMLElement, CustomProps>(function IbanMaskCustom(props, ref: any) {
    const { onChange, ...other } = props;
    return (
        <IMaskInput
            {...other}
            mask="AA99 9999 9999 9999 9999 9999 999"
            definitions={{
                A: /[A-Z]/,
                9: /[A-Z0-9]/,
            }}
            name={props.name}
            value={props.value}
            onChange={props.onChange as any}
            inputRef={ref}
            onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
            overwrite
        />
    );
});
/**
 * Objet qui permet d'avoir les props de formik plus les attributs que le veut custom
 */
type MyInputProps = FieldHookConfig<string> & {
    required?: boolean;
    id: string;
    label?: string;
    name: string;
};

/**
 * Composant select
 * @param props MyInputProps
 * @constructor
 */
export default function InputIbanForm(props: MyInputProps) {
    const [field, meta] = useField(props);
    //Création du champ input
    return (
        <FormControl fullWidth error={!!meta.error} required={props.required}>
            <InputLabel htmlFor={props.id}>{props.label}</InputLabel>
            <OutlinedInput
                {...field}
                id={props.id}
                data-testid={props.id}
                label={props.label}
                name={props.name}
                inputComponent={ibanMaskCustom as any}
            />
            <FormHelperText id={props.id} error={!!meta.error}>
                {meta.error}
            </FormHelperText>
        </FormControl>
    );
}
